import React from 'react';
import { motion } from 'framer-motion';
import { CalendarCheck, CheckCircle2, Truck } from 'lucide-react';
import { Button } from '../ui/Button';
interface HeroProps {
  onReserve: () => void;
}
const HIGHLIGHTS = ['Flat, all-in pricing', 'Next-day delivery', 'Pay by card or cash on delivery'];
export function Hero({
  onReserve
}: HeroProps) {
  return <section id="top" className="w-full bg-background" data-id="element-221">
      <div className="container grid gap-10 py-16 md:grid-cols-2 md:items-center md:py-24" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-223">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1 text-xs font-medium text-secondary-foreground" data-id="element-224">
            <Truck className="h-3.5 w-3.5 text-primary" data-id="element-225" />
            Serving the greater metro area
          </span>
          <h1 className="mt-5 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl" data-id="element-226">
            Dumpster rentals made simple, fast, and fair.
          </h1>
          <p className="mt-4 max-w-lg text-lg text-muted-foreground" data-id="element-227">
            Reserve the right size online in minutes. We deliver, you fill it,
            we haul it away — with straightforward pricing and no surprise fees.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-228">
            <Button size="lg" onClick={onReserve} className="gap-2" data-id="element-229">
              <CalendarCheck className="h-4 w-4" data-id="element-230" />
              Reserve a dumpster
            </Button>
            <Button size="lg" variant="outline" onClick={() => {
            document.getElementById("sizes")?.scrollIntoView({
              behavior: "smooth"
            });
          }} data-id="element-231">
              View sizes & pricing
            </Button>
          </div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-232">
            {HIGHLIGHTS.map(item => <li key={item} className="flex items-center gap-2 text-sm text-foreground" data-id="element-233">
                <CheckCircle2 className="h-4 w-4 text-primary" data-id="element-234" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} className="relative" data-id="element-235">
          <div className="overflow-hidden rounded-2xl border border-border shadow-sm" data-id="element-236">
            <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=80" alt="A roll-off dumpster delivered on a residential driveway" className="h-full w-full object-cover" data-id="element-237" />
          </div>
          <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 shadow-md" data-id="element-238">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-239">
              <Truck className="h-5 w-5" data-id="element-240" />
            </span>
            <div className="leading-tight" data-id="element-241">
              <p className="text-sm font-semibold text-card-foreground" data-id="element-242">
                Next-day delivery
              </p>
              <p className="text-xs text-muted-foreground" data-id="element-243">
                Available in most areas
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}